import React, { useState } from "react"
import Icon from "../../../components/AppIcon"
import Input from "../../../components/ui/Input"
import Button from "../../../components/ui/Button"
import QuestionListEditor from "./QuestionListEditor"
import { generateLocalId } from "../../../utils/courseHelpers"

const createEmptyQuiz = () => ({
  id: generateLocalId(),
  title: "Module Quiz",
  passingScore: 70,
  pointsReward: 10,
  questions: [],
})

const QuizEditor = ({ quiz, onChange }) => {
  const [expanded, setExpanded] = useState(!!quiz)

  if (!quiz) {
    return (
      <div className="border border-dashed border-border rounded-lg p-4">
        <Button variant="ghost" size="sm" iconName="ListChecks" iconPosition="left" onClick={() => { onChange(createEmptyQuiz()); setExpanded(true) }}>
          Add Quiz to This Module
        </Button>
      </div>
    )
  }

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <button
        onClick={() => setExpanded((e) => !e)}
        className="w-full flex items-center justify-between px-4 py-3 bg-muted/30 hover:bg-muted/50 transition-smooth"
      >
        <span className="flex items-center gap-2 text-sm font-medium text-foreground">
          <Icon name="ListChecks" size={16} /> Module Quiz ({quiz?.questions?.length || 0} questions)
        </span>
        <Icon name={expanded ? "ChevronUp" : "ChevronDown"} size={16} className="text-muted-foreground" />
      </button>

      {expanded && (
        <div className="p-4 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <Input
              label="Quiz Title"
              value={quiz?.title}
              onChange={(e) => onChange({ ...quiz, title: e?.target?.value })}
            />
            <Input
              label="Passing Score (%)"
              type="number"
              value={quiz?.passingScore}
              onChange={(e) => onChange({ ...quiz, passingScore: Number(e?.target?.value) || 0 })}
            />
            <Input
              label="Points Reward"
              type="number"
              value={quiz?.pointsReward}
              onChange={(e) => onChange({ ...quiz, pointsReward: Number(e?.target?.value) || 0 })}
            />
          </div>

          <QuestionListEditor
            questions={quiz?.questions || []}
            onChange={(questions) => onChange({ ...quiz, questions })}
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            iconPosition="left"
            className="text-destructive"
            onClick={() => {
              if (window.confirm("Remove this module's quiz entirely?")) onChange(null)
            }}
          >
            Remove Quiz
          </Button>
        </div>
      )}
    </div>
  )
}

export default QuizEditor
